export const CoordinationOfCare = {
    physicianNotified: {
        version: ['e1'],
        timepoint: ['soc', 'roc'],
    },
    clinicianName: {
        version: ['e1'],
        timepoint: ['soc', 'roc'],
    },
    collaboratorName: {
        version: ['e1'],
        timepoint: ['soc', 'roc'],
    },
    nextVisitPlans: {
        version: ['e1'],
        timepoint: ['soc', 'roc'],
    },
    coordinationDiscipline: {
        version: ['e1'],
        timepoint: ['soc', 'roc'],
    },
    coordinationName: {
        version: ['e1'],
        timepoint: ['soc', 'roc'],
    },
};
